import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const StarIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 18.0909L16.969 21.0899C17.753 21.5629 18.72 20.8599 18.512 19.9689L17.193 14.3159L21.584 10.5119C22.276 9.91291 21.906 8.77591 20.994 8.69891L15.214 8.20891L12.953 2.87391C12.596 2.03291 11.404 2.03291 11.047 2.87391L8.78599 8.20891L3.00599 8.69891C2.09399 8.77591 1.72399 9.91291 2.41599 10.5119L6.80699 14.3159L5.48799 19.9689C5.27999 20.8599 6.24699 21.5629 7.03099 21.0899L12 18.0909Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

StarIcon.propTypes = {
  sx: PropTypes.object,
};

export default StarIcon;
